import { FAVORITE_DELIVERY_TYPE } from 'common/constants';
import React from 'react';
import { ChevronRightIcon, DotsThreeIcon } from '@fronton/icons-react';
import { TFunction } from 'i18next';
import { AddressSheetItemType } from './utils';

const selectionGroupItems = [
  { id: FAVORITE_DELIVERY_TYPE.REGION, icon: <ChevronRightIcon /> },
  { id: FAVORITE_DELIVERY_TYPE.PICKUP, icon: <DotsThreeIcon /> },
  { id: FAVORITE_DELIVERY_TYPE.PICKUP_POINT, icon: <DotsThreeIcon /> },
  { id: FAVORITE_DELIVERY_TYPE.HOME_DELIVERY, icon: <DotsThreeIcon /> },
] as const;

type SelectionGroupListItem = {
  id: AddressSheetItemType;
  name: string;
  description: string;
  priceText: string | undefined;
  icon: React.ReactNode;
};

const getItemTexts = (id: AddressSheetItemType, t: TFunction) => {
  switch (id) {
    case FAVORITE_DELIVERY_TYPE.REGION:
      return {
        name: t('header.main.favorite-address.region-label'),
        description: t('header.main.favorite-address.address-menu.items.region.description'),
        priceText: undefined,
      };
    case FAVORITE_DELIVERY_TYPE.PICKUP:
      return {
        name: t('header.main.favorite-address.address-menu.items.pickup.name'),
        description: t('header.main.favorite-address.address-menu.items.pickup.description'),
        priceText: t('header.main.favorite-address.address-menu.items.pickup.price'),
      };
    case FAVORITE_DELIVERY_TYPE.PICKUP_POINT:
      return {
        name: t('header.main.favorite-address.address-menu.items.pickup-point.name'),
        description: t('header.main.favorite-address.address-menu.items.pickup-point.description'),
        priceText: t('header.main.favorite-address.address-menu.items.pickup-point.price'),
      };
    case FAVORITE_DELIVERY_TYPE.HOME_DELIVERY:
      return {
        name: t('header.main.favorite-address.home-delivery'),
        description: t('header.main.favorite-address.address-menu.items.delivery.description'),
        priceText: undefined,
      };
  }
};

export const getSelectionGroupList = (t: TFunction): SelectionGroupListItem[] =>
  selectionGroupItems.map(({ id, icon }) => ({
    id,
    icon,
    ...getItemTexts(id, t),
  }));
